
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0H1a1 1 0 00-1 1v14a1 1 0 001 1h9a1 1 0 001-1V1a1 1 0 00-1-1zM23 8h-9a1 1 0 00-1 1v14a1 1 0 001 1h9a1 1 0 001-1V9a1 1 0 00-1-1zM23 0h-9a1 1 0 00-1 1v4a1 1 0 001 1h9a1 1 0 001-1V1a1 1 0 00-1-1zM10 18H1a1 1 0 00-1 1v4a1 1 0 001 1h9a1 1 0 001-1v-4a1 1 0 00-1-1z"}})])
          )
        }
      }
    